import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function Pricing() {
  const tiers = [{
    name: 'Próba',
    price: '0',
    period: 'Free',
    description: 'Perfect for testing the waters.',
    features: ['1,000 characters/month', '2 Voice Models', 'Standard Quality', 'Personal Use Only'],
    cta: 'Start Free',
    variant: 'outline' as const
  }, {
    name: 'Rzemieślnik',
    price: '149',
    period: 'PLN/mo',
    description: 'For creators and indie developers.',
    features: ['50,000 characters/month', 'All Voice Models', 'High Quality (48kHz)', 'API Access', 'Commercial License'],
    cta: 'Select Plan',
    variant: 'outline' as const
  }, {
    name: 'Wirtuoz',
    price: '449',
    period: 'PLN/mo',
    description: 'For professional studios and agencies.',
    features: ['200,000 characters/month', 'Priority Rendering', 'Lossless WAV Export', 'Batch Processing', 'Commercial License'],
    cta: 'Go Virtuoso',
    variant: 'primary' as const,
    highlight: true
  }, {
    name: 'Studio',
    price: '1,299',
    period: 'PLN/mo',
    description: 'Enterprise scale production.',
    features: ['Unlimited characters', 'Custom Voice Training', 'Dedicated Support', 'SLA Guarantee', 'On-premise Option'],
    cta: 'Contact Sales',
    variant: 'secondary' as const
  }];
  return <section id="pricing" className="py-24 bg-[#0A0A0F] relative overflow-hidden" data-id="element-117">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#00F0FF] opacity-5 blur-[120px] rounded-full pointer-events-none" data-id="element-118"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-121">
            Choose Your Sound
          </h2>
          <p className="text-gray-400" data-id="element-122">
            Transparent pricing in PLN. Cancel anytime.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6" data-id="element-123">
          {tiers.map(tier => <div key={tier.name} className={`flex flex-col p-6 rounded-2xl border ${tier.highlight ? 'border-[#00F0FF] bg-[#00F0FF]/5 shadow-[0_0_30px_rgba(0,240,255,0.1)]' : 'border-white/10 bg-[#13131F]'} transition-transform hover:-translate-y-1`} data-id="element-124">
              <div className="mb-8" data-id="element-125">
                <h3 className="text-lg font-mono font-bold text-white mb-2" data-id="element-126">
                  {tier.name}
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-127">
                  <span className="text-3xl font-bold text-white" data-id="element-128">
                    {tier.price}
                  </span>
                  <span className="text-sm text-gray-400" data-id="element-129">{tier.period}</span>
                </div>
                <p className="text-sm text-gray-400 mt-4" data-id="element-130">{tier.description}</p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-131">
                {tier.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-132">
                    <Check size={16} className={`mt-0.5 flex-shrink-0 ${tier.highlight ? 'text-[#00F0FF]' : 'text-gray-500'}`} data-id="element-133" />
                    <span data-id="element-134">{feature}</span>
                  </li>)}
              </ul>

              <Button variant={tier.variant} className="w-full" data-id="element-135">
                {tier.cta}
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}